var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrupoMultitecnica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "138.13px",
    viewBox: "0 0 500 138.13",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M207.926,71.705c0.384-5.314-3.052-9.021-8.366-9.021 c-5.208,0-9.296,3.708-9.682,9.021c-0.38,5.118,3.048,8.924,8.352,8.924C203.351,80.628,207.525,77.015,207.926,71.705 L207.926,71.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M251.919,46.285c1.098-1.649,3.322-2.091,4.979-0.991 c1.654,1.102,2.1,3.333,0.986,4.983c-1.098,1.646-3.327,2.09-4.981,0.99C251.262,50.167,250.818,47.938,251.919,46.285 L251.919,46.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M211.108,49.311c2.132-3.194,6.453-4.052,9.642-1.922 c3.189,2.134,4.057,6.458,1.925,9.65c-2.135,3.194-6.456,4.056-9.651,1.923C209.838,56.823,208.968,52.509,211.108,49.311 L211.108,49.311z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M233.482,42.256c1.576-2.368,4.773-3.009,7.156-1.423 c2.367,1.581,3.005,4.784,1.421,7.156c-1.584,2.371-4.79,3.007-7.152,1.422C232.53,47.829,231.89,44.629,233.482,42.256 L233.482,42.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M469.873,120.034c-0.354,4.7-4.078,7.011-7.268,7.011 c-2.756,0-5.094-1.773-4.803-5.853c0.429-5.77,6.068-7.637,12.543-7.637L469.873,120.034L469.873,120.034z M485.943,107.791 c0.824-11.092-2.482-21.56-18.99-21.56c-8.603-0.001-15.265,2.487-18.597,4.261l2.094,10.116c3.348-1.953,7.881-3.375,12.581-3.375 c6.31,0,7.783,2.749,7.505,6.563c-14.729,0.09-26.955,5.766-27.935,18.99c-0.622,8.422,4.818,15.344,13.853,15.344 c5.153,0,9.989-1.772,13.306-5.765h0.258l0.539,4.792h14.022c-0.412-3.021-0.261-7.363,0.063-11.802L485.943,107.791 L485.943,107.791z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M437.36,124.465c-2.006,0.806-4.361,1.246-7.104,1.246 c-6.653,0-11.257-4.879-10.612-13.573c0.505-8.073,5.441-13.573,12.531-13.573c3.114,0,5.196,0.621,6.747,1.153l3.092-11.802 c-2.157-0.796-5.823-1.595-9.728-1.595c-16.764,0-27.366,11.356-28.484,26.439c-1.184,15.965,7.63,25.279,22.532,25.279 c4.87-0.001,9.374-0.883,11.576-1.859L437.36,124.465L437.36,124.465z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    points: "399.547,87.208 383.936,87.208 380.238,137.158 395.854,137.158 399.547,87.208 "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M375.492,106.726c0.964-12.952-4.066-20.495-14.532-20.495 c-6.927-0.001-11.901,3.906-14.385,7.275h-0.255l-0.344-6.298H332.58c-0.165,4.701-0.394,10.024-0.826,15.97l-2.51,33.979h15.609 l2.17-29.277c0.472-6.387,4.104-8.782,7.392-8.782c4.437,0,5.749,3.813,5.361,9.047l-2.146,29.013h15.623L375.492,106.726 L375.492,106.726z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M323.07,124.465c-2.007,0.806-4.352,1.246-7.106,1.246 c-6.648,0-11.252-4.879-10.609-13.573c0.512-8.073,5.445-13.573,12.54-13.573c3.109,0,5.191,0.621,6.749,1.153l3.087-11.802 c-2.157-0.796-5.823-1.595-9.729-1.595c-16.764,0-27.364,11.356-28.478,26.439c-1.188,15.965,7.618,25.279,22.521,25.279 c4.885-0.001,9.377-0.883,11.583-1.859L323.07,124.465L323.07,124.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M257.024,106.995c0.57-4.173,3.051-10.028,8.369-10.028 c5.419,0,6.417,5.595,6.091,10.028H257.024L257.024,106.995z M279.957,124.465c-3.646,1.157-7.613,1.955-12.126,1.955 c-6.481,0-11.594-2.751-11.515-8.691l28.213-0.002c0.488-1.684,0.756-4.172,0.93-6.564c1.254-16.947-6.579-24.932-18.472-24.932 c-14.898-0.001-24.171,12.511-25.224,26.796c-1.16,15.612,7.013,25.014,22.721,25.014c5.94-0.001,11.949-0.883,16.709-2.751 L279.957,124.465L279.957,124.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M214.386,87.208h-6.118l-0.826,11.265h6.112l-1.533,20.764 c-0.425,5.677-1.13,18.804,14.211,18.804c4.177-0.001,7.67-0.53,9.679-1.147l0.799-12.071c-1.358,0.36-2.338,0.449-4.112,0.449 c-3.73,0-5.432-2.133-5-7.986l1.392-18.812h10.378l0.84-11.265h-10.385l1-13.482l-15.757,4.345L214.386,87.208L214.386,87.208z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#50BFA2",
    points: "203.291,87.208 187.674,87.208 183.981,137.158 199.602,137.158 203.291,87.208 "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#50BFA2",
    d: "M156.598,87.208h-6.12l-0.836,11.265h6.122l-1.54,20.764 c-0.41,5.677-1.126,18.804,14.227,18.804c4.176-0.001,7.67-0.53,9.673-1.147l0.8-12.071c-1.356,0.36-2.341,0.449-4.109,0.449 c-3.731,0-5.435-2.133-5.004-7.986l1.394-18.812h10.379l0.832-11.265h-10.373l0.999-13.482l-15.763,4.345L156.598,87.208 L156.598,87.208z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#50BFA2",
    points: "147.093,65.65 131.497,65.65 126.188,137.158 141.813,137.158 147.093,65.65 "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#50BFA2",
    d: "M121.95,87.208h-15.607l-2.275,30.606 c-0.369,5.056-3.657,7.541-6.85,7.541c-4.353,0-5.929-3.905-5.417-10.644l2.021-27.504H78.219l-2.204,29.72 c-1.061,14.371,4.114,21.202,14.228,21.202c7.268,0,12.089-3.992,14.455-7.188h0.272l0.25,6.215h13.472 c0.152-4.438,0.293-9.941,0.754-16.059L121.95,87.208L121.95,87.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#50BFA2",
    d: "M70.016,68.576H51.205l-7.496,22.09 c-2.626,7.989-5.227,16.768-7.228,24.666h-0.362c-0.73-8.074-2.058-16.411-3.408-24.571l-3.864-22.185H9.773L0,137.158h14.009 l2.963-24.396c0.905-7.364,2.058-17.035,2.951-25.553h0.269c0.799,8.431,2.055,17.744,3.268,24.309l4.313,24.395h11.795 l8.556-24.57c2.35-6.564,5.438-15.884,7.822-24.133h0.27c-0.764,9.052-1.086,18.188-1.264,25.462l-0.836,24.487h14.728 L70.016,68.576L70.016,68.576z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M492.649,132.018h1.22c0.602,0,0.984-0.084,1.202-0.263 c0.21-0.172,0.316-0.403,0.316-0.685c-0.012-0.184-0.065-0.35-0.165-0.495c-0.104-0.149-0.258-0.253-0.428-0.326 c-0.192-0.072-0.523-0.11-1.015-0.11h-1.156L492.649,132.018L492.649,132.018z M491.681,135.532h1.003l-0.021-2.649h0.581 c0.36-0.003,0.625,0.071,0.817,0.213c0.276,0.193,0.631,0.678,1.077,1.454l0.562,0.982h1.23l-0.78-1.219 c-0.371-0.582-0.682-0.997-0.938-1.239c-0.136-0.13-0.31-0.238-0.538-0.333c0.548-0.036,0.974-0.225,1.292-0.571 c0.328-0.338,0.493-0.73,0.493-1.187c-0.013-0.323-0.124-0.627-0.31-0.913c-0.199-0.288-0.469-0.492-0.801-0.604 c-0.324-0.119-0.856-0.171-1.592-0.171l-2.143-0.001L491.681,135.532L491.681,135.532z M494.134,127.48 c-0.808,0-1.603,0.208-2.372,0.627c-0.771,0.419-1.362,1.019-1.787,1.793c-0.436,0.775-0.641,1.587-0.635,2.426 c0.012,0.838,0.238,1.642,0.671,2.408c0.447,0.768,1.045,1.363,1.826,1.795c0.77,0.426,1.575,0.645,2.41,0.645 c0.83,0,1.647-0.219,2.415-0.645c0.753-0.432,1.34-1.027,1.761-1.795c0.425-0.767,0.617-1.57,0.615-2.408 c-0.009-0.839-0.233-1.65-0.682-2.426c-0.437-0.774-1.054-1.374-1.84-1.793C495.747,127.688,494.946,127.48,494.134,127.48 L494.134,127.48z M494.127,126.515c0.98,0,1.926,0.251,2.867,0.75c0.928,0.501,1.664,1.218,2.187,2.15 c0.539,0.93,0.808,1.907,0.819,2.91c0,1.004-0.237,1.965-0.733,2.887c-0.502,0.928-1.206,1.642-2.13,2.151 c-0.907,0.517-1.871,0.767-2.881,0.767c-1.012,0-1.962-0.25-2.899-0.767c-0.923-0.51-1.651-1.224-2.165-2.151 c-0.534-0.922-0.79-1.883-0.813-2.887c-0.012-1.003,0.246-1.98,0.753-2.91c0.514-0.933,1.229-1.649,2.148-2.15 C492.215,126.766,493.156,126.515,494.127,126.515L494.127,126.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#50BFA2",
    d: "M260.707,81.018c0.584-2.462,2.955-7.166,11.98-12.331 c13.218-7.564,12.349-9.537,12.349-9.537c1.876,10.558-0.268,18.164-4.712,24.08c-3.97-2.103-10.413-3.074-14.998-2.956 C263.756,80.405,262.207,80.656,260.707,81.018L260.707,81.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#50BFA2",
    d: "M268.762,57.105c1.951,3.138,2.202,5.841,2.898,9.02 c-8.758,3.829-12.712,8.552-14.239,13.713C252.618,67.897,262.977,65.158,268.762,57.105L268.762,57.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#192964",
    d: "M386.154,71.843c2.48-3.587,7.354-4.551,10.879-2.158 c3.521,2.396,4.379,7.251,1.896,10.835c-2.483,3.587-7.36,4.553-10.889,2.159C384.522,80.278,383.664,75.434,386.154,71.843 L386.154,71.843z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupoMultitecnica);
export default __webpack_public_path__ + "static/media/Grupo-Multitecnica.e589961b7e55b2891d16ec3c959e162a.svg";
export { ForwardRef as ReactComponent };